import { createSlice, PayloadAction } from '@reduxjs/toolkit'

//The initial state

const initialState: any = {}

//Creating a slice with state interaction functions

export const webCallReducer = createSlice({
    name: 'webcall',
    initialState,
    reducers: {
        getContactData: (state, action: PayloadAction<any>): any => ({
            ...state,
            ...action.payload
        }),
        clearContactData: (): any => initialState,

    },
})


export const { getContactData, clearContactData} = webCallReducer.actions

export default webCallReducer.reducer